module.exports = __webpack_public_path__ + "static/media/three.59401a9e.svg";